import type { AxiosResponse } from "axios";

import config from "@/common/config";
import type { ApiResponse } from "@/types/api.type";
import type { SearchResponse } from "@/types/inflection-trainer.type";

import ApiService from "./api.service";

export default {
  NAMESPACE: config.api.inflectionTrainer.namespace,
  VERSION: config.api.inflectionTrainer.versions.v1,

  search(query: string): Promise<AxiosResponse<ApiResponse<SearchResponse>>> {
    return ApiService.post(`/search`, { query }, this.VERSION, this.NAMESPACE);
  }
};
